// Side-effect module: MUST be the first import of src/index.js.
//
// ej2-react components get ComponentBase through applyMixins, which COPIES the
// prototype methods onto each component class when its module evaluates
// (ej2-react-base/src/util.js). Patching ComponentBase.prototype therefore only
// reaches components whose module evaluates after the patch. ES imports are
// hoisted and evaluated in order, so an install call placed in the body of
// index.js runs after the whole ./App graph — and that graph eagerly pulls
// @syncfusion/ej2-react-charts (usageReducer imports its `sum` helper), which
// would leave ChartComponent & co. with the unguarded refreshProperties.
// Importing this module first makes the guards run before any component module.
// syncfusionObserverGuard.mixins.test.js pins both the order and the effect.
import { installSyncfusionObserverGuard } from "./syncfusionObserverGuard";

installSyncfusionObserverGuard();
